module.exports = __webpack_public_path__ + "static/media/icon-left.4c12086a.svg";